module.exports = __webpack_public_path__ + "img/freestyle_box06.b439856e.jpg";